import { FC } from 'react'
import { Input, InputProps } from './Input'

export const INTEGER_REGEX = /^(0|[1-9]\d*)?$/
export const DECIMAL_REGEX = /^(0|[1-9]\d*)(\.\d{0,2})?$/

export type NumberInputProps = Omit<InputProps, 'onChange'> & {
  onChange: (value: string) => void
  decimal?: boolean
  max?: number
  min?: number
}

export const NumberInput: FC<NumberInputProps> = ({ onChange, decimal, max, min, ...props }) => {
  const handleChange = (value: string) => {
    const regex = decimal ? DECIMAL_REGEX : INTEGER_REGEX

    if (value === '') {
      onChange(value)
      return
    }

    if (!regex.test(value)) {
      return
    }

    const numValue = Number(value)
    if (!isNaN(numValue)) {
      if (max !== undefined && numValue > max) {
        return
      }
      if (min !== undefined && numValue < min) {
        return
      }
    }

    onChange(value)
  }

  return <Input {...props} value={props.value} onChange={handleChange} />
}
